<template>
  <div class="container" id="profile-container" :style="{'--rotateDeg': rotateDeg}">
    <div class="header">
      <van-icon
          class="header-return"
          name="arrow-left"
          size="25"
          color="#333333"
          @click="onClickHeaderReturn()"
      />
      Edit Personal Info
    </div>

    <div class="content">

      <div class="avatar-content">
        <Avatar :size="80" :update-profile="false" @change="onAvatarChange"/>
        <span>{{ userInfo.nickName }}</span>
        <span class="third-color text-14px">{{ userInfo.email }}</span>
      </div>

      <div class="info-items">
        <div class="horizontal items-center justify-between ml-11 mr-9" style="margin-top:66px;font-size:16px;">
          <span>Name:</span>
          <div class="horizontal items-center third-color" @click="onEditNickName">{{ profile.nickName }}
            <van-image :src="require('@/assets/icons/v2/profile/icon_profile_edit.svg')" class="ml-2"/>
          </div>
        </div>
        <div class="horizontal items-center justify-between ml-11 mr-9" style="font-size:16px;">
          <span>Account:</span>
          <div class="horizontal items-center third-color">{{ userInfo.email }}
          </div>
        </div>
        <div class="horizontal items-center justify-between ml-11 mr-9" style="font-size:16px;">
          <span>Birth Date:</span>
          <div class="horizontal items-center third-color" @click="showBirthDatePopup = true">{{ birthDateText }}
            <van-image :src="require('@/assets/icons/v2/profile/icon_profile_edit.svg')" class="ml-2"/>
          </div>
        </div>
        <div class="horizontal items-center justify-between ml-11 mr-9" style="font-size:16px;">
          <span>Gender:</span>
          <div class="horizontal items-center third-color" @click="onShowGender">
            <van-popover get-container="#profile-container" v-model="showGender" :actions="actions"
                @select="onSelectGender">
              <template #reference>
                <span style="font-size:14px;">{{ genderText }}</span>
              </template>
            </van-popover>
            <van-image :src="require('@/assets/icons/v2/ic_home_right_arrow.svg')"
                class="ml-2 right-icon-anim"/>
          </div>
        </div>
        <div class="horizontal items-center justify-between ml-11 mr-9" style="font-size:16px;">
          <span>Registration Date:</span>
          <div class="horizontal items-center third-color">{{ userInfo.createTime }}
          </div>
        </div>
        <div class="w-full mt-12 horizontal items-center">
          <button @click="onUpdateProfile" type="submit" class="apply-btn" style="width:80%">Apply</button>
        </div>
      </div>
    </div>

    <PopupSingleEdit v-model="showEditNamePopup" title="Edit Name" placeholder="Enter name"
        @onConfirm="onNickNameChange"/>

    <popup-date v-model="showBirthDatePopup" :current-select-time="profile.dateOfBirth"
        @onCancel="showBirthDatePopup = false" @onApply="onApplyDate"/>

  </div>
</template>


<script>

import Avatar from "@/components/profile/Avatar.vue";
import { mapState } from "vuex";
import PopupSingleEdit from "@/components/common/PopupSingleEdit.vue";
import PopupDate from "@/components/common/PopupDate.vue";
import { getMonthEn } from "@/util/utils";
import user from "@/api/user";

export default {
  name: "EditPersonalInfo",
  components: { PopupDate, PopupSingleEdit, Avatar },
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      showEditNamePopup: false,

      showBirthDatePopup: false,

      profile: {
        nickName: "",
        dateOfBirth: "",
        gender: 3,
        picture: null
      },
      genderText: "Male",
      birthDateText: "",
      showGender: false,
      showPopover: false,
      actions: [
        { text: "Male", value: 0 },
        { text: "Female", value: 1 },
        { text: "Other", value: 2 },
        { text: "Not to disclose", value: 3 }
      ],
      rotateDeg: 0
    };
  },
  methods: {
    onAvatarChange({ avatarUrl }) {
      this.profile.picture = avatarUrl;
    },
    onShowGender() {
      this.showGender = !this.showGender;
    },
    onSelectGender(action, index) {
      this.profile.gender = action.value;
      this.genderText = action.text;
    },
    onClickHeaderReturn() {
      this.$router.back();
    },
    onEditNickName() {
      this.showEditNamePopup = true;
    },
    onNickNameChange(e) {
      this.showEditNamePopup = false;
      this.profile.nickName = e;
    },
    onApplyDate(e) {
      if (!e) {
        this.$toast({
          message: "Please select day"
        })
        return
      }
      this.showBirthDatePopup = false;
      this.birthDateText = `${getMonthEn(e.month - 1)}${e.day}, ${e.year}`;
      const month = `${e.month}`.padStart(2, 0);
      const day = `${e.day}`.padStart(2, 0);
      this.profile.dateOfBirth = `${e.year}-${month}-${day}`;
    },
    async onUpdateProfile() {
      const data = { ...this.profile };
      const resp = await user.updateUserProfile2(data);
      if (resp.code !== 200) {
        this.$toast({
          message: resp.message
        });
        return;
      }
      await this.$toast({
        message: resp.message
      });
      await this.$store.dispatch("user/updateUser", data);
      await this.$router.back();
    },
    handleDateOfBirth() {
      const checkDate = this.userInfo.dateOfBirth && new Date(this.userInfo.dateOfBirth).toString() !== "Invalid Date";
      if (!checkDate) {
        return "";
      }
      const e = new Date(this.userInfo.dateOfBirth);
      return `${getMonthEn(e.getMonth())}${e.getDate()}, ${e.getFullYear()}`;
    }
  },
  watch: {
    showGender(val) {
      if (val) {
        this.rotateDeg = "90deg";
      } else {
        this.rotateDeg = "0deg";
      }
    }
  },
  computed: {
    ...mapState("user", ["userInfo"])
  },
  mounted() {
    this.profile.nickName = this.userInfo.nickName;
    this.profile.dateOfBirth = this.userInfo.dateOfBirth;
    this.profile.gender = this.userInfo.gender ;
    this.profile.picture = this.userInfo.picture;
    this.birthDateText = this.handleDateOfBirth();
    this.genderText = (this.userInfo.gender && this.actions[this.userInfo.gender].text) || "";
  }
};
</script>
<style scoped lang="less">
.container {

  background: white;

  .header {
    width: 100%;
    height: 60px;
    min-height: 60px;

    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #333333;
    background: white;

    .header-return {
      position: absolute;
      left: 10px;
    }
  }

  .content {
    background: white;

    & > * + * {
      margin-top: 12px;
    }
  }

}


.avatar-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.apply-btn {
  height: 48px;
  line-height: 48px;
  border-radius: 12px;
  border: 1px solid #BEBEBE;
  margin: 48px 56px 0 48px;
  color: #333333;
  font-size: 20px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-items {
  font-size: 16px;

  & > * + * {
    margin-top: 48px;
  }

  // iPhone13
  @media only screen and (min-device-width: 390px)  and (-webkit-device-pixel-ratio: 3) {

    & > * + * {
      margin-top: 48px;
    }

    .apply-btn {
      margin-top: 80px;
    }
  }
  // iPhoneXSMax
  @media only screen and (min-device-width: 414px)  and (-webkit-device-pixel-ratio: 3) {
    & > * + * {
      margin-top: 53px;
    }

    .apply-btn {
      margin-top: 140px;
    }
  }
  // iPhone13 pro max
  @media only screen and (min-device-width: 428px)  and (-webkit-device-pixel-ratio: 3) {
    & > * + * {
      margin-top: 53px;
    }

    .apply-btn {
      margin-top: 140px;
    }
  }
}

::v-deep .van-popover__action {
  padding: 0;
  font-size: 14px;
}

::v-deep .van-popover__arrow {
  border-width: 0px;
}

.right-icon-anim {
  transition: all 0.3s ease-in-out;
  transform: rotate(var(--rotateDeg))
}
</style>